import type { AssignmentCreationData } from '@/types/Models/Assignment'
import { computed, type ComputedRef } from 'vue'
import { SINGLE } from '@/const/AssignmentTypes'

export const useValidationRules = (assignment: ComputedRef<AssignmentCreationData>) => {
  return computed(() => {
    const isSwedenPicked = assignment.value.item.country_code === 'SE'
    return {
      deliveryType: {
        required: true,
      },
      email: {
        email: true,
        required: true,
      },
      lettersField: {
        alpha_spaces: true,
        required: true,
        min: 3,
      },
      description: {
        required: !isSwedenPicked && assignment.value.assignment_type === SINGLE,
        min: 3,
        max: 30,
      },
      reference: {
        required: false,
        min: 3,
        max: 34,
      },
      message: {
        required: false,
        min: 3,
      },
      customer_id: {
        required: true,
        min: 3,
      },
      file: {
        required: true,
        min: 1,
      },
      emailRule: {
        emailPhoneRequired: (isSwedenPicked && assignment.value.item.phone_number.length === 0) || !isSwedenPicked,
        email: true,
      },
      phoneRule: {
        simplePhone: assignment.value.item.country_code,
        emailPhoneRequired: (isSwedenPicked && assignment.value.item.email.length === 0) || !isSwedenPicked,
      },
    }
  })
}
